import type { ReactElement } from 'react'

import { cn } from '../../../../lib/utils.ts'

import { ItemMetadataContext } from './item-metadata-context.ts'

export function ItemActions(props: ItemActions.Props): ReactElement {
  const { className, ...rest } = props
  return (
    // Cuts the row's metadata scope: an `Item.Title` or `Item.Description` inside the actions labels the action, not the
    // row, so it must not register as the name or description of the row's control.
    <ItemMetadataContext.Provider value={undefined}>
      <div
        data-slot="item-actions"
        className={cn('ml-auto flex shrink-0 items-center gap-inline text-icon-base', className)}
        {...rest}
      />
    </ItemMetadataContext.Provider>
  )
}
export namespace ItemActions {
  export type Props = React.ComponentProps<'div'>
}
